import { Badge, CardTitle, Typography } from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import React from 'react';
import { ICardHeader } from '../../../models/purchase-history';
import { orderNumberFormat } from '../../shared/order-number-formatter/OrderNumberFormatter';
import { dateFormat } from '../../order-details/util/format';
import { monthDayYear } from '../../../constants/dateStrings';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';

export const CardHeader = ({
  orderNumber,
  POJobName,
  projectName,
  registerNumber,
  salesDate,
  totalAmount,
  transactionId,
  cpsDataSource,
}: ICardHeader) => {
  const { customerType } = usePurchaseHistoryContext();
  return (
    <>
      <CardTitle
        disableTypography
        header={
          <>
            <div className="sui-flex sui-gap-[8px]">
              {POJobName && POJobName !== orderNumber && (
                <div>
                  <Badge
                    variant="regular"
                    color="info"
                    style={{
                      fontSize: '12px',
                      marginBottom: '12px',
                      backgroundColor: '#E3F7F6',
                      padding: '0px 8px',
                    }}
                  >
                    {POJobName}
                  </Badge>
                </div>
              )}
              {FeatureSwitches.enableProjectName &&
                cpsDataSource === 'CPS' &&
                projectName && (
                  <div>
                    <Badge
                      variant="regular"
                      color="info"
                      style={{
                        fontSize: '12px',
                        marginBottom: '12px',
                        backgroundColor: '#E3F7F6',
                        padding: '0px 8px',
                      }}
                    >
                      {projectName}
                    </Badge>
                  </div>
                )}
            </div>
            <Typography weight="bold" variant="h3" height="tight">
              {orderNumberFormat(
                orderNumber,
                transactionId,
                registerNumber,
                true,
                customerType,
              )}
            </Typography>
          </>
        }
        subheader={
          <>
            <Typography variant="body-lg" color="subtle">
              {salesDate
                ? dateFormat(salesDate, monthDayYear)
                : 'Date Unavailable'}{' '}
              {totalAmount !== null &&
                totalAmount !== undefined &&
                totalAmount?.toFixed(2) !== 'NaN' &&
                `| Total: ${totalAmount >= 0 ? '' : '-'}$${(totalAmount >= 0
                  ? totalAmount
                  : totalAmount * -1
                )?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} `}
            </Typography>
          </>
        }
        action={
          <div className="sui-mt-[12px]">
            <ArrowForward />
          </div>
        }
      />
    </>
  );
};
